var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"creation-footer"},[_c('vi-button',{staticClass:"creation-footer_button",attrs:{"type":"primary","size":"lg","disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('next-step')}}},[_vm._v("\n    "+_vm._s(_vm.$t(_vm.content))+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }